/* ============================================================
   MX MOTORSPORTS – Widerrufsfunktion („Vertrag widerrufen“), Ablauf
   Datei: assets/mx-widerruf.js
   Gehört zu sections/mx-widerruf.liquid und assets/mx-widerruf.css

   1. Angaben prüfen  ->  2. Zusammenfassung, „Widerruf bestätigen“
   ->  3. Eingang mit Datum und Uhrzeit (Europe/Berlin)

   Übermittlung beim Bestätigen:
   a) Klaviyo Client API, Ereignis „Widerruf erklärt“ (öffentlicher Schlüssel,
      KEINE Newsletter-Anmeldung). Der Flow „Widerruf – Eingangsbestätigung“
      schickt daraufhin die Eingangsbestätigung per E-Mail.
   b) optional (data-kontakt="an") das Shopify-Kontaktformular im Hintergrund.
   Uhrzeit des Eingangs: aus dem Date-Kopf der Shop-Antwort (Serverzeit),
   nur wenn der fehlt, aus der Uhr des Browsers.
   ============================================================ */
(function(){
  'use strict';
  var root = document.querySelector('[data-mxw]');
  if(!root || root.getAttribute('data-mxw-init')) return;
  root.setAttribute('data-mxw-init', '1');

  var METRIK = 'Widerruf erklärt';
  var REVISION = '2026-07-15';
  var form = root.querySelector('[data-mxw-form]');
  var schritt = {
    1: root.querySelector('[data-mxw-step="1"]'),
    2: root.querySelector('[data-mxw-step="2"]'),
    3: root.querySelector('[data-mxw-step="3"]')
  };
  if(!form || !schritt[1] || !schritt[2] || !schritt[3]) return;

  var $ = function(id){ return document.getElementById(id); };
  var btnWeiter = root.querySelector('[data-mxw-weiter]');
  var btnBest = root.querySelector('[data-mxw-bestaetigen]');
  var btnZurueck = root.querySelector('[data-mxw-zurueck]');
  var btnDruck = root.querySelector('[data-mxw-drucken]');
  var errBox = root.querySelector('[data-mxw-errors]');
  var errList = root.querySelector('[data-mxw-errlist]');
  var failBox = root.querySelector('[data-mxw-fail]');
  var mailRe = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var FELDER = [
    { id:'mxw-name', name:'Vor- und Nachname', pflicht:true,
      pruef:function(v){ return v.length >= 3 && /\S+\s+\S+/.test(v); },
      leer:'Bitte gib deinen Vor- und Nachnamen ein.',
      falsch:'Bitte gib Vor- und Nachnamen ein, z. B. Max Mustermann.' },
    { id:'mxw-mail', name:'E-Mail-Adresse', pflicht:true,
      pruef:function(v){ return mailRe.test(v); },
      leer:'Bitte gib deine E-Mail-Adresse ein.',
      falsch:'Bitte gib eine gültige E-Mail-Adresse ein, z. B. name@beispiel.de.' },
    { id:'mxw-nr', name:'Bestellnummer', pflicht:true,
      pruef:function(v){ return /[0-9A-Za-z]/.test(v); },
      leer:'Bitte gib deine Bestellnummer ein, z. B. #1234.',
      falsch:'Bitte gib deine Bestellnummer ein, z. B. #1234.' }
  ];

  /* Vorbelegung der Bestellnummer aus dem Link in Bestellbestätigung oder Kundenkonto:
     /pages/widerruf?bestellung=%231234 */
  (function(){
    try {
      var nr = (new URLSearchParams(window.location.search).get('bestellung') || '').replace(/[^\w#\-\/ ]/g, '').trim().slice(0, 40);
      var el = $('mxw-nr');
      if(nr && el && !el.value) el.value = nr;
    } catch(e){}
  })();

  function wert(id){ var el = $(id); return el ? String(el.value || '').replace(/\s+$/,'').replace(/^\s+/,'') : ''; }
  function einzeilig(t){ return String(t || '').replace(/\s+/g, ' ').trim(); }

  /* ---------- Fehleranzeige ---------- */
  function setzeFehler(f, text){
    var el = $(f.id), err = $(f.id + '-err');
    if(!el || !err) return;
    if(text){
      el.setAttribute('aria-invalid', 'true');
      err.textContent = text;
      err.hidden = false;
    } else {
      el.removeAttribute('aria-invalid');
      err.textContent = '';
      err.hidden = true;
    }
  }
  function pruefeFeld(f){
    var v = wert(f.id);
    if(!v) return f.pflicht ? f.leer : '';
    return f.pruef(v) ? '' : f.falsch;
  }
  function pruefeAlle(){
    var fehler = [];
    FELDER.forEach(function(f){
      var t = pruefeFeld(f);
      setzeFehler(f, t);
      if(t) fehler.push({ f:f, t:t });
    });
    errList.innerHTML = '';
    if(fehler.length){
      fehler.forEach(function(x){
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + x.f.id;
        a.textContent = x.f.name + ': ' + x.t;
        a.addEventListener('click', function(ev){ ev.preventDefault(); var el = $(x.f.id); if(el){ el.focus(); } });
        li.appendChild(a); errList.appendChild(li);
      });
      errBox.hidden = false;
    } else {
      errBox.hidden = true;
    }
    return fehler;
  }
  /* Nach dem ersten Fehlversuch: Fehler beim Tippen live aufheben */
  var versucht = false;
  FELDER.forEach(function(f){
    var el = $(f.id); if(!el) return;
    el.addEventListener('input', function(){
      if(!versucht) return;
      if(!pruefeFeld(f)) setzeFehler(f, '');
    });
    el.addEventListener('blur', function(){
      if(!versucht) return;
      setzeFehler(f, pruefeFeld(f));
      if(!FELDER.some(function(x){ return pruefeFeld(x); })) errBox.hidden = true;
    });
  });

  /* ---------- Daten der Erklärung ---------- */
  function daten(){
    var name = einzeilig(wert('mxw-name'));
    var teile = name.split(' ');
    var nachname = teile.length > 1 ? teile.pop() : '';
    var vorname = teile.join(' ');
    var nr = einzeilig(wert('mxw-nr'));
    if(/^\d+$/.test(nr)) nr = '#' + nr;
    var artikel = wert('mxw-artikel');
    var umfang = artikel ? 'Einzelne Artikel' : 'Ganze Bestellung';
    var erkl = 'Hiermit widerrufe ich, ' + name + ', den mit MX Motorsports geschlossenen Vertrag über die Bestellung ' + nr +
      (artikel ? ' für folgende Artikel: ' + einzeilig(artikel) + '.' : ' (ganze Bestellung).');
    return {
      name:name, vorname:vorname, nachname:nachname,
      email:einzeilig(wert('mxw-mail')).toLowerCase(),
      nr:nr, datum:einzeilig(wert('mxw-datum')),
      artikel:artikel, umfang:umfang, nachricht:wert('mxw-nachricht'),
      erklaerung:erkl
    };
  }

  function zeilen(d, mitZeit){
    var z = [];
    if(mitZeit) z.push(['Eingegangen am', mitZeit]);
    z.push(['Name', d.name], ['E-Mail', d.email], ['Bestellnummer', d.nr],
           ['Bestelldatum bzw. Erhalt', d.datum || 'nicht angegeben'],
           ['Umfang', d.umfang]);
    if(d.artikel) z.push(['Betroffene Artikel', d.artikel]);
    z.push(['Nachricht', d.nachricht || 'keine']);
    return z;
  }
  function fuelleSumme(box, d, zeit){
    box.querySelector('[data-mxw-erklaerung]').textContent = d.erklaerung;
    var dl = box.querySelector('[data-mxw-sum]');
    dl.innerHTML = '';
    zeilen(d, zeit).forEach(function(p){
      var dt = document.createElement('dt'), dd = document.createElement('dd');
      dt.textContent = p[0]; dd.textContent = p[1];
      dl.appendChild(dt); dl.appendChild(dd);
    });
  }

  /* ---------- Schritte ---------- */
  function zeige(n){
    [1,2,3].forEach(function(i){ schritt[i].hidden = (i !== n); });
    /* Nach dem Eingang keinen zweiten Weg mehr anbieten (sonst doppelte Widerrufe per E-Mail) */
    var info = root.querySelector('.mxw__info'); if(info) info.hidden = (n === 3);
    Array.prototype.forEach.call(root.querySelectorAll('[data-mxw-nav]'), function(li){
      var i = +li.getAttribute('data-mxw-nav');
      li.classList.toggle('is-current', i === n);
      li.classList.toggle('is-done', i < n);
      if(i === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
    var h = $('mxw-h-' + n);
    var nav = root.querySelector('.mxw__nav');
    var ziel = nav || schritt[n];
    /* Platz für den mitlaufenden Shop-Header lassen */
    var kopf = 0, hd = document.querySelector('.section-header');
    if(hd){ var pos = getComputedStyle(hd).position; if(pos === 'sticky' || pos === 'fixed') kopf = hd.getBoundingClientRect().height; }
    var top = ziel.getBoundingClientRect().top + window.pageYOffset - kopf - 16;
    if(window.pageYOffset > top) window.scrollTo(0, Math.max(0, top));
    if(h){ try { h.focus({ preventScroll:true }); } catch(e){ h.focus(); } }
  }

  btnWeiter.addEventListener('click', function(){
    versucht = true;
    var fehler = pruefeAlle();
    if(fehler.length){
      try { errBox.focus({ preventScroll:true }); } catch(e){ errBox.focus(); }
      errBox.scrollIntoView({ block:'center' });
      return;
    }
    failBox.hidden = true;
    fuelleSumme(schritt[2], daten(), '');
    zeige(2);
  });
  /* Enter in einem einzeiligen Feld = Weiter */
  form.addEventListener('keydown', function(ev){
    if(ev.key === 'Enter' && ev.target && ev.target.tagName === 'INPUT' && !schritt[1].hidden){
      ev.preventDefault(); btnWeiter.click();
    }
  });
  btnZurueck.addEventListener('click', function(){ eindeutig = null; zeige(1); });
  if(btnDruck) btnDruck.addEventListener('click', function(){ window.print(); });

  /* ---------- Zeit ---------- */
  function berlin(date){
    var teile = {};
    new Intl.DateTimeFormat('de-DE', { timeZone:'Europe/Berlin', year:'numeric', month:'2-digit', day:'2-digit',
      hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23' })
      .formatToParts(date).forEach(function(p){ teile[p.type] = p.value; });
    var y = +teile.year, mo = +teile.month, d = +teile.day, h = +teile.hour % 24, mi = +teile.minute, s = +teile.second;
    var off = Math.round((Date.UTC(y, mo - 1, d, h, mi, s) - Math.floor(date.getTime() / 1000) * 1000) / 60000);
    var pad = function(n){ return (n < 10 ? '0' : '') + n; };
    var vz = off >= 0 ? '+' : '-', ab = Math.abs(off);
    return {
      iso: y + '-' + pad(mo) + '-' + pad(d) + 'T' + pad(h) + ':' + pad(mi) + ':' + pad(s) + vz + pad(Math.floor(ab / 60)) + ':' + pad(ab % 60),
      lesbar: pad(d) + '.' + pad(mo) + '.' + y + ', ' + pad(h) + ':' + pad(mi) + ' Uhr',
      text: pad(d) + '.' + pad(mo) + '.' + y + ' um ' + pad(h) + ':' + pad(mi) + ' Uhr'
    };
  }
  function serverZeit(){
    var start = Date.now();
    return fetch('/cart.js', { method:'GET', cache:'no-store', credentials:'same-origin', headers:{ 'Accept':'application/json' } })
      .then(function(r){
        var h = r.headers.get('Date'); var t = h ? Date.parse(h) : NaN;
        if(isNaN(t)) throw new Error('kein Date-Kopf');
        return { date:new Date(t + Math.min(1500, Math.round((Date.now() - start) / 2))), quelle:'Shop-Server' };
      })
      .catch(function(){ return { date:new Date(), quelle:'Browser' }; });
  }

  /* ---------- Übermittlung ---------- */
  function schluessel(){
    var k = (root.getAttribute('data-klaviyo-key') || '').trim();
    if(!k && window.MXS && window.MXS.kl && window.MXS.kl.k) k = window.MXS.kl.k;
    return k;
  }
  var eindeutig = null;
  function neueId(){
    try { if(window.crypto && crypto.randomUUID) return 'widerruf-' + crypto.randomUUID(); } catch(e){}
    return 'widerruf-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function anKlaviyo(d, z){
    var k = schluessel();
    if(!k) return Promise.reject(new Error('kein Klaviyo-Schlüssel'));
    var body = { data:{ type:'event', attributes:{
      properties:{
        Bestellnummer:d.nr,
        Bestelldatum:d.datum,
        Artikel:d.artikel,
        Umfang:d.umfang,
        Nachricht:d.nachricht,
        Name:d.name,
        Vorname:d.vorname,
        Nachname:d.nachname,
        Email:d.email,
        Erklaerung:d.erklaerung,
        eingegangen_am:z.iso,
        eingegangen_am_lesbar:z.lesbar,
        eingegangen_am_utc:z.utc,
        Zeitquelle:z.quelle,
        Quelle:root.getAttribute('data-quelle') || 'mx-motorsports.de/pages/widerruf'
      },
      time:z.utc,
      unique_id:eindeutig,
      metric:{ data:{ type:'metric', attributes:{ name:METRIK } } },
      profile:{ data:{ type:'profile', attributes:{ email:d.email, first_name:d.vorname || d.name, last_name:d.nachname } } }
    } } };
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(k), {
      /* KEIN keepalive: Chrome bricht keepalive-Anfragen mit CORS-Vorabprüfung ab
         („Failed to fetch“). Die Seite bleibt ja stehen, keepalive ist unnötig. */
      method:'POST', mode:'cors',
      headers:{ 'Content-Type':'application/json', 'revision':REVISION },
      body:JSON.stringify(body)
    }).then(function(r){
      if(r.ok || r.status === 202) return 'ok';
      return r.text().then(function(t){ throw new Error('HTTP ' + r.status + ' ' + String(t).slice(0, 200)); });
    });
  }

  function anKontakt(d, z){
    var kf = document.getElementById('mxw-kontakt');
    if(root.getAttribute('data-kontakt') !== 'an' || !kf) return Promise.resolve('aus');
    var setze = function(n, v){ var el = kf.querySelector('[name="contact[' + n + ']"]'); if(el) el.value = v; };
    setze('Name', d.name); setze('email', d.email); setze('Bestellnummer', d.nr);
    setze('Bestelldatum bzw. Erhalt', d.datum || 'nicht angegeben');
    setze('Betroffene Artikel', d.artikel || 'ganze Bestellung');
    setze('Nachricht', d.nachricht || '–');
    setze('Erklärung', d.erklaerung);
    setze('Eingegangen am', z.lesbar + ' (' + z.iso + ')');
    setze('body', 'Widerruf über die Widerrufsfunktion auf ' + (root.getAttribute('data-quelle') || 'mx-motorsports.de/pages/widerruf'));
    return fetch(kf.getAttribute('action') || '/contact', {
      method:'POST', body:new FormData(kf), credentials:'same-origin', redirect:'follow'
    }).then(function(r){
      var u = r.url || '';
      if(/challenge/i.test(u)) return 'captcha';
      if(!r.ok) return 'fehler ' + r.status;
      return /contact_posted=true/.test(u) ? 'ok' : 'ok?';
    }).catch(function(e){ return 'fehler ' + (e && e.message ? e.message : ''); });
  }

  function mailtoLink(d, z){
    var mail = root.getAttribute('data-mail') || 'info@mx-motorsports.de';
    var text = d.erklaerung + '\n\n' + zeilen(d, z ? z.lesbar : '').map(function(p){ return p[0] + ': ' + p[1]; }).join('\n');
    return 'mailto:' + mail + '?subject=' + encodeURIComponent('Widerruf – Bestellung ' + d.nr) + '&body=' + encodeURIComponent(text);
  }

  var laeuft = false;
  btnBest.addEventListener('click', function(){
    if(laeuft) return;
    laeuft = true;
    var d = daten();
    if(!eindeutig) eindeutig = neueId();
    failBox.hidden = true;
    btnBest.disabled = true; btnZurueck.disabled = true;
    btnBest.setAttribute('aria-busy', 'true');
    var span = btnBest.querySelector('span'), alt = span.textContent;
    span.textContent = 'Wird übermittelt …';

    serverZeit().then(function(t){
      var z = berlin(t.date);
      z.utc = new Date(Math.floor(t.date.getTime() / 1000) * 1000).toISOString().replace('.000Z', 'Z');
      z.quelle = t.quelle;
      return anKlaviyo(d, z).then(function(){
        root.setAttribute('data-mxw-klaviyo', 'ok');
        anKontakt(d, z).then(function(st){ root.setAttribute('data-mxw-kontakt-status', st); });
        fuelleSumme(schritt[3], d, z.lesbar);
        schritt[3].querySelector('[data-mxw-zeit]').textContent = z.text;
        schritt[3].querySelector('[data-mxw-mailziel]').textContent = d.email;
        form.reset();
        Array.prototype.forEach.call(form.querySelectorAll('input,textarea,button'), function(el){ el.disabled = true; });
        zeige(3);
      }, function(err){
        root.setAttribute('data-mxw-klaviyo', 'fehler: ' + (err && err.message ? err.message : ''));
        var a = failBox.querySelector('[data-mxw-mailto]');
        if(a) a.href = mailtoLink(d, z);
        failBox.hidden = false;
        try { failBox.focus({ preventScroll:true }); } catch(e){ failBox.focus(); }
        failBox.scrollIntoView({ block:'center' });
        btnBest.disabled = false; btnZurueck.disabled = false;
        btnBest.removeAttribute('aria-busy');
        span.textContent = alt;
        laeuft = false;
      });
    });
  });
})();

/* ENDE – diese Zeile muss nach dem Einfügen sichtbar sein, sonst ist die Datei abgeschnitten */
